import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displaySuccessMessage } from "store/actions/utilActions";
//#endregion
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { ResetPasswordProps } from "models/propTypes/loginPropTypes";
//#endregion
//#region components
import { ActionLinkButton, Icon, StyledButton, useEnterPressHandler, useMountedState } from "components/common";
import ResetPasswordFormContainer from "./forms/resetPasswordFormContainer";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ResetPassword: React.FC<ResetPasswordProps> = (props) => {
  const [isSubmitting, setSubmitting] = React.useState<boolean>(false);
  const formRef = React.useRef<FormHandles>(null);
  const { getMounted } = useMountedState();
  const navigate = useNavigate();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onSubmitClick = () => {
    setSubmitting(true);
    return (
      (formRef.current &&
        formRef.current.submit().then(() => {
          dispatch(
            displaySuccessMessage(
              LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.PasswordResetSuccessMessage)
            )
          );
          navigate(-1);
        })) ||
      new Promise<void>((resolve) => resolve())
    ).finally(() => {
      getMounted() && setSubmitting(false);
    });
  };

  useEnterPressHandler(onSubmitClick);

  return (
    <>
      <Grid container className={cssExports.topContent}>
        <ActionLinkButton
          onClick={() => {
            navigate(-1);
          }}
          startIcon={<Icon icon={IconDefinitionConstants.WChevronLeft} />}
        >
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Login)}
        </ActionLinkButton>
      </Grid>
      <Grid container spacing={4}>
        <Grid item>
          <Grid item className={cssExports.loginHeader}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Title)}
          </Grid>
        </Grid>
        <Grid item container justifyContent="flex-start" spacing={3}>
          <Grid item container className={cssExports.loginFormContainer} spacing={0}>
            <ResetPasswordFormContainer ref={formRef} />
          </Grid>
          <Grid item container>
            <StyledButton
              type="submit"
              onClick={onSubmitClick}
              className={cssExports.loginButton}
              isSubmitting={isSubmitting}
              displayType={props.displayType}
            >
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Send)}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ResetPassword;
